function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import XLSX from 'xlsx';
import Somos1DataEntryService from '@/apps/customer-insigths/services/somos1_data_entry_service';
import tasks from '@/js/tasks';
import firebase from 'firebase';
import { mapMutations, mapState } from 'vuex';
export default {
  name: 'Somos1DataEntryBulkUpload',
  data: function data() {
    var _this = this;
    return {
      disabled: false,
      loading_download: false,
      DIALOG_REWRITE_SUBMIT: 'DIALOG_REWRITE_SUBMIT',
      save_event: null,
      idOrganization: 0,
      template_name: '',
      organizationName: '',
      File: [],
      hasFile: false,
      excel_file: null,
      uploadIcon: 'upload.png',
      isInlearning: false,
      INLEARNING_DOMAIN: 'inlearning.pe',
      isInretailpharma: false,
      INRETAILPHARMA_DOMAIN: 'inretailpharma.com',
      organization_id: 0,
      company_code: '0',
      organizationsList: [],
      year_id: 0,
      yearsList: [],
      month_id: 0,
      monthsList: [{
        id: 1,
        name: this.translate('customer_insights.data_entry.header.january')
      }, {
        id: 2,
        name: this.translate('customer_insights.data_entry.header.february')
      }, {
        id: 3,
        name: this.translate('customer_insights.data_entry.header.march')
      }, {
        id: 4,
        name: this.translate('customer_insights.data_entry.header.april')
      }, {
        id: 5,
        name: this.translate('customer_insights.data_entry.header.may')
      }, {
        id: 6,
        name: this.translate('customer_insights.data_entry.header.june')
      }, {
        id: 7,
        name: this.translate('customer_insights.data_entry.header.july')
      }, {
        id: 8,
        name: this.translate('customer_insights.data_entry.header.august')
      }, {
        id: 9,
        name: this.translate('customer_insights.data_entry.header.september')
      }, {
        id: 10,
        name: this.translate('customer_insights.data_entry.header.october')
      }, {
        id: 11,
        name: this.translate('customer_insights.data_entry.header.november')
      }, {
        id: 12,
        name: this.translate('customer_insights.data_entry.header.december')
      }],
      data_entry_list: null,
      organization_indicators_list: [],
      regions_list: [],
      data_built: [],
      data_load: [],
      load_header: [],
      load_brands: [],
      load_body: [],
      load_group: [],
      valid: true,
      xlsxFile: null,
      rules: {
        year: [function (v) {
          return !!v || _this.translate('customer_insights.rules.year');
        }],
        month: [function (v) {
          return !!v || _this.translate('customer_insights.rules.month');
        }],
        file: [function (v) {
          return !!v || _this.translate('customer_insights.rules.file');
        }, function (v) {
          return !v || v.size < 2000000 || _this.translate('customer_insights.rules.file_size');
        }]
      }
    };
  },
  created: function created() {
    var _this2 = this;
    this.disabled = false;
    this.$emit('update:disabled', this.disabled);
    this.getYears();
    if (this.INLEARNING_DOMAIN === this.getDomainUser() || this.INRETAILPHARMA_DOMAIN === this.getDomainUser()) {
      if (this.INLEARNING_DOMAIN === this.getDomainUser()) this.isInlearning = true;
      if (this.INRETAILPHARMA_DOMAIN === this.getDomainUser()) this.isInretailpharma = true;
      this.getOrganizationsList();
      this.rules = {
        year: [function (v) {
          return !!v || _this2.translate('customer_insights.rules.year');
        }],
        month: [function (v) {
          return !!v || _this2.translate('customer_insights.rules.month');
        }],
        file: [function (v) {
          return !!v || _this2.translate('customer_insights.rules.file');
        }, function (v) {
          return !v || v.size < 2000000 || _this2.translate('customer_insights.rules.file_size');
        }],
        organization: [function (v) {
          return !!v || _this2.translate('customer_insights.rules.organization');
        }]
      };
    } else {
      this.getOrganizationInfo();
      this.getOrganizationIndicatorsList();
    }
    this.getRegionsList();
  },
  beforeMount: function beforeMount() {},
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    label: function label() {
      return {
        year: this.translate('customer_insights.label.year'),
        month: this.translate('customer_insights.label.month')
      };
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    importXlsx: function importXlsx() {
      var _this3 = this;
      if (!this.xlsxFile) {
        this.hasFile = false;
        return;
      }
      var reader = new FileReader();
      this.load_body = [];
      reader.onload = function (e) {
        _this3.hasFile = true;
        var bstr = e.target.result;
        var wb = XLSX.read(bstr, {
          type: 'binary'
        });
        _this3.excel_file = btoa(bstr);
        /* Get first worksheet */
        var wsname = wb.SheetNames[1];
        var ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        var json = XLSX.utils.sheet_to_json(ws, {
          header: 1
        });
        var p;
        for (p in json) {
          _this3.load_body.push(json[p]);
          console.log('cargado correctamente!');
        }
      };
      reader.readAsBinaryString(this.xlsxFile);
    },
    upload: function upload(rewrite) {
      var _this4 = this;
      try {
        if ((this.INLEARNING_DOMAIN === this.getDomainUser() || this.INRETAILPHARMA_DOMAIN === this.getDomainUser()) && this.organization_id === '0') {
          return;
        }
        this.setShowLoading(true);
        console.log(this.regions_list);
        console.log(this.organization_indicators_list);
        console.log('this.load_body');
        console.log(this.load_body);
        this.load_brands = this.load_body[0];
        this.load_header = this.load_body[1];
        console.log('this.load_brands');
        console.log(this.load_brands);
        console.log('this.load_brands[0]');
        console.log(this.load_brands[0]);
        // if (this.load_brands[0] !== this.organizationName) {
        //   tasks.toast.error('Archivo incorrecto')
        //   return
        // }
        var replicar;
        for (var x = 0; x < this.load_header.length; x++) {
          console.log('this.load_brands[i]');
          console.log(this.load_brands[x]);
          if (this.load_brands[x]) {
            replicar = this.load_brands[x];
          } else {
            this.load_brands[x] = replicar;
          }
        }
        console.log('------------this.load_brands');
        console.log(this.load_brands);
        console.log(this.load_brands[0]);

        // this.load_header.shift()
        console.log('this.load_header');
        console.log(this.load_header);
        for (var i = 2; i < this.load_body.length; i++) {
          for (var j = 1; j < this.load_body[i].length; j++) {
            var new_data_load_element = {
              region: this.load_body[i][0],
              brand: this.load_brands[j],
              indicator: this.load_header[j],
              id_organization: this.idOrganization,
              value: this.load_body[i][j]
            };
            this.data_load.push(new_data_load_element);
          }
        }
        console.log('-----data load');
        console.log(this.data_load);
        // -----------------------------------------------------------------------
        for (var m = 0; m < this.organization_indicators_list.length; m++) {
          for (var n = 0; n < this.regions_list.length; n++) {
            var new_data_built_element = {
              region: this.regions_list[n].name,
              id_region: this.regions_list[n].id_region,
              id_indicator: this.organization_indicators_list[m].id_indicator,
              indicator: this.organization_indicators_list[m].indicator,
              id_brand: this.organization_indicators_list[m].id_brand,
              brand: this.organization_indicators_list[m].brand
            };
            this.data_built.push(new_data_built_element);
          }
        }
        console.log('-----data built');
        console.log(this.data_built);
        // -----------------------------------------------------------------------
        var merged = this.Merge(this.data_built, this.data_load);
        var result = merged.filter(function (item) {
          return typeof item.value === 'number';
        });
        var bulk = {
          rewrite: rewrite,
          id_organization: this.idOrganization,
          month: this.month_id,
          year: this.year_id
        };
      } catch (error) {
        console.error(error);
        tasks.toast.error('archivo incorrecto');
      }
      var body = {
        data: result,
        bulk: bulk,
        file: this.excel_file,
        original_file_name: this.xlsxFile.name
      };
      console.log('body');
      console.log(body);
      Somos1DataEntryService.postDataEntryAll(body, this.company_code).then(function (response) {
        console.log(response);
        if (response.success && response.code === 200) {
          tasks.toast.success('Subido con éxito');
        } else {
          tasks.toast.error('error');
        }
        _this4.cleanLoad();
      }).catch(function (err) {
        if (err.response.data.data.error_info[0].type === 'type_error.none.not_allowed') {
          tasks.toast.error(_this4.translate('error_messages.error_general'), _this4.translate('attributes.error.required'));
        } else {
          tasks.toast.error(_this4.translate('error_messages.error_general'), _this4.translate('titles.error'));
        }
      }).finally(function () {
        _this4.setShowLoading(false);
        _this4.$emit('close');
      });
    },
    onSubmit: function onSubmit(event) {
      var _this5 = this;
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      var bulk = {
        id_organization: this.idOrganization,
        month: this.month_id,
        year: this.year_id
      };
      var body = {
        data: bulk
      };
      this.disabled = true;
      this.$emit('update:disabled', this.disabled);
      Somos1DataEntryService.postVerifyBulk(body, this.company_code).then(function (response) {
        if (response.data) {
          _this5.openDialog(_this5.DIALOG_REWRITE_SUBMIT);
        } else {
          _this5.upload(false);
        }
      });
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    onSubmitRewrite: function onSubmitRewrite(valor) {
      if (valor) {
        this.upload(true);
        this.$refs[this.DIALOG_REWRITE_SUBMIT].onClose();
      } else {
        this.disabled = false;
        this.$emit('update:disabled', this.disabled);
        this.$refs[this.DIALOG_REWRITE_SUBMIT].onClose();
      }
    },
    Merge: function Merge(obj1, obj2) {
      var obj3 = [];
      for (var x in obj1) {
        for (var y in obj2) {
          if (obj1[x].region === obj2[y].region && obj1[x].indicator === obj2[y].indicator && obj1[x].brand === obj2[y].brand) {
            var z = _objectSpread(_objectSpread({}, obj1[x]), obj2[y]);
            obj3.push(z);
          }
        }
      }
      return obj3;
    },
    downloadXlsx: function downloadXlsx() {
      var _this6 = this;
      this.loading_download = true;
      firebase.storage().ref('templates_xlsx/' + this.template_name).getDownloadURL().then(function (url) {
        window.location = url;
        _this6.loading_download = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getOrganizationInfo: function getOrganizationInfo() {
      var _this7 = this;
      Somos1DataEntryService.getOrganization().then(function (response) {
        _this7.idOrganization = response.data.id_organization;
        _this7.organizationName = response.data.name;
        _this7.template_name = response.data.template_name;
        // this.isInlearning = false
        // if (this.companyCode === '038') {
        //   this.isInlearning = true
        // }
      });
    },
    getOrganizationInfoByCompanyCode: function getOrganizationInfoByCompanyCode() {
      var _this8 = this;
      Somos1DataEntryService.getOrganization({}, this.company_code).then(function (response) {
        _this8.idOrganization = response.data.id_organization;
        _this8.organizationName = response.data.name;
        _this8.template_name = response.data.template_name;
      });
    },
    getOrganizationsList: function getOrganizationsList() {
      var _this9 = this;
      Somos1DataEntryService.getOrganizationsList().then(function (response) {
        _this9.organizationsList = response.data.filter(function (item) {
          return _this9.isInlearning && (item.company_code === '064' || item.company_code === '041' || item.company_code === '058') || _this9.isInretailpharma && (item.company_code === '074' || item.company_code === '044');
        });
      });
    },
    getOrganizationIndicatorsList: function getOrganizationIndicatorsList() {
      var _this0 = this;
      Somos1DataEntryService.getOrganizationIndicatorsList({}, this.company_code).then(function (response) {
        _this0.organization_indicators_list = response.data;
      });
    },
    getRegionsList: function getRegionsList() {
      var _this1 = this;
      Somos1DataEntryService.getRegionsList().then(function (response) {
        _this1.regions_list = response.data;
      });
    },
    getYears: function getYears() {
      var d = new Date();
      var thisYear = d.getFullYear();
      for (var i = 2022; i <= thisYear; i++) {
        this.yearsList.push({
          id: i,
          name: i
        });
      }
      /*this.yearsList.push(
        { id: thisYear - 1, name: thisYear - 1 }
      )
      this.yearsList.push(
        { id: thisYear, name: thisYear }
      )*/
    },
    changeOrganization: function changeOrganization() {
      var _this10 = this;
      this.company_code = this.organizationsList.find(function (v) {
        return v.id_organization === _this10.organization_id;
      }).company_code;
      this.getOrganizationInfoByCompanyCode();
      this.getOrganizationIndicatorsList();
    },
    dropFile: function dropFile(e) {
      this.File = e.dataTransfer.files;
      if (this.File.length > 0) {
        this.xlsxFile = e.dataTransfer.files[0];
        this.excel_file = null;
        this.importXlsx();
      }
    },
    cleanLoad: function cleanLoad() {
      this.data_load = [];
      this.data_built = [];
      this.load_body = [];
      this.xlsxFile = null;
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    getDomainUser: function getDomainUser() {
      return window.userInfo.domain;
    }
  })
};